import React from "react";
import { Image, StyleSheet, View } from "@react-pdf/renderer";

export const LogoBlock = ({ themeData }) => {
  const logoBlock = StyleSheet.create({
    logo: {
      position: "absolute",
      width: "150px",
      top: 10,
      right: 10,
    },
  });

  return (
    <View data-testid="logo-block">
      <Image src={themeData.logo} style={logoBlock.logo} />
    </View>
  );
};
